import './custom.css';
import * as React from 'react';
import { Provider } from 'react-redux';
import AppContainer from './AppContainer';
import store from './redux/store';
import CacheBuster, { useCacheBuster } from 'react-cache-buster';
import { version } from '../package.json';
import { Loading } from './components';
import { isProdEnv } from './env';

export const getVersion = () => version;

const App = () => {
  const isProduction = isProdEnv();
    const VersionCheckButton = () => {
        const { checkCacheStatus } = useCacheBuster();

        return <button onClick={checkCacheStatus}>Check for new version</button>;
    };
  return (
    <CacheBuster
      currentVersion={version}
      isEnabled={isProduction} //If false, the library is disabled.
      isVerboseMode={false} //If true, the library writes verbose logs to console.
      loadingComponent={<Loading />} //If not pass, nothing appears at the time of new version check.
    >
      <Provider store={store}>
        <AppContainer />
          </Provider>
          <VersionCheckButton/>
    </CacheBuster>
  );
};

export default App;
